import getCookieByName from './getCookieByName';

/**
  * Returns the content for cookie or meta tag
  */
 export default function getCookieOrMeta(name) {
  const tag = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  return getCookieByName(name.replace(/-/g, '_')) || tag?.content;
}
